const { default: CommonServices } = require("./common/common");

class PodcastManagementService extends CommonServices {
  constructor() {
    super("/podcasts");
  }
}

const podcastManagementService = new PodcastManagementService();
export default podcastManagementService;
